const showIntercomButton = () => {
    try {
        window.Intercom('update', {
            hide_default_launcher: false,
        });
    }
    catch (error) {
        console.error('Error showing Intercom button:', error);
    }
};
const hideIntercomButton = () => {
    try {
        window.Intercom('update', {
            hide_default_launcher: true,
        });
    }
    catch (error) {
        console.error('Error hiding Intercom button:', error);
    }
};
const showIntercomMessenger = () => {
    try {
        showIntercomButton();
        window.Intercom('show');
        window.Intercom('onHide', () => {
            hideIntercomButton();
        });
    }
    catch (error) {
        console.error('Error showing Intercom messenger:', error);
    }
};

export { hideIntercomButton, showIntercomButton, showIntercomMessenger };
